import { Box, Typography } from "@mui/material"
import constructionGif from "../../assets/gifs/construction.gif"

const Maintenance = ({
    isMobileDevice
}: {
    isMobileDevice: boolean
}) => {
    return (
        <Box
            component="main"
            width="100vw"
            height="100vh"
            display="flex"
            flexDirection="column"
            justifyContent="center"
        >
            <Box display="flex" justifyContent="center" marginBottom={"2.5%"}>
                <img src={constructionGif} alt="Ícone de Cavalete de Obra" width="128" height="128" />
            </Box>
            <Box display="flex" justifyContent="center">
                <Typography variant={isMobileDevice ? "h5" : "h4"} gutterBottom>
                    Página em manutenção
                </Typography>
            </Box>
            <Box display="flex" justifyContent="center">
                <Typography variant="body1" sx={{
                    textWrap: "pretty"
                }}>
                    A página está temporariamente indisponível, mas garanto que ela estará de volta em breve! 😉
                </Typography>
            </Box>
        </Box>
    )
}

export default Maintenance